import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useMatches, useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';
import styles from './index.module.scss';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getPid } from '../../../../utils/utils';
import { Button } from 'antd';
import { MenuOutlined } from '@ant-design/icons';

const { wrapper, breadcrumbs, currentCrumb, projectHome, collapseButton } =
  styles;

const Breadcrumbs = ({ onToggleMenu }) => {
  const intl = useIntl();
  const params = useParams();
  const location = useLocation();
  const matches = useMatches();
  const crumbs = matches.filter((match) => Boolean(match.handle?.crumb));
  const project = useSelector((state) =>
    state.projects.list.find(
      (project) =>
        project.id_project ===
        (params?.id || location.search
          ? parseInt(params.id || getPid(location.search), 10)
          : 0),
    ),
  );
  const getBreadcrumb = useCallback(
    ({ index, handle, pathname, params }) => {
      const crumbText = `${
        handle.isProjectHome ? project?.name ?? '' : handle.crumb
      }`;
      const isLastCrumb = index === crumbs.length - 1;

      if (isLastCrumb) {
        return <span className={currentCrumb}>{crumbText}</span>;
      } else {
        return (
          <>
            <Link
              to={pathname}
              className={handle.isProjectHome ? projectHome : ''}
            >
              {crumbText}
            </Link>
            {!isLastCrumb && ' > '}
          </>
        );
      }
    },
    [crumbs.length, project?.name],
  );
  return (
    <div className={wrapper}>
      <ul className={breadcrumbs}>
        {!location.pathname.includes('projects') &&
          !location.pathname.includes('app/users') && (
            <li>
              <div className={collapseButton}>
                <Button
                  onClick={onToggleMenu}
                  type="icon"
                  icon={<MenuOutlined color="white" />}
                />
              </div>
            </li>
          )}
        {((crumbs.length > 1 && location.pathname.includes('project/')) ||
          (crumbs.length === 1 && location.pathname.includes('project/'))) && (
          <li>
            <Link to="/app/projects">
              {intl.formatMessage({ id: 'routes.projects' })}
            </Link>
            {crumbs.length < 1 ? '' : ' > '}
          </li>
        )}
        {crumbs.map(({ handle, pathname, params }, index) => {
          return (
            <Fragment key={index}>
              <li key={index}>
                {getBreadcrumb({ index, handle, pathname, params })}
              </li>
            </Fragment>
          );
        })}
      </ul>
    </div>
  );
};

Breadcrumbs.propTypes = {
  onToggleMenu: PropTypes.func.isRequired,
};

export default Breadcrumbs;
